import ChooseSavedCard from "../../components/payment/ChooseSavedCard";
import { Box, Typography } from "@mui/material";
import PaymentHeader from "../../components/payment/PaymentHeader";
import { AdDrawerStyledButton } from "../../components/commonComponents/adDetails/style";
import { NavigatePrevIcon } from "../../assets/Icons";
import { useNavigate } from "react-router-dom";
import {
  CustomContainer,
  PlanDetails,
  PlanHeader,
} from "../../components/payment/style";

const ChooseSavedCardPage = () => {
  const navigate = useNavigate();
  const content = {
    headerTitle: "Choose a Saved Card",
    tabTitle: "Select Card",
    tabSubTitle: "Pick a saved card to proceed with your payment",
  };

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#FFF",
        gap: "25px",
      }}
    >
      <PaymentHeader />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "25px",
          maxWidth: "1100px",
          marginBottom: "30px",
        }}
      >
        <Box sx={{ display: "flex", width: "100%" }}>
          <AdDrawerStyledButton onClick={() => navigate(-1)}>
            <NavigatePrevIcon />
            Back
          </AdDrawerStyledButton>
          <Typography
            style={{
              fontWeight: 700,
              fontSize: "32px",
              color: "#414042",
              textAlign: "center",
              flex: 1,
            }}
          >
            {content?.headerTitle}
          </Typography>
        </Box>
        <Box display="flex" flexDirection="column" gap="30px">
          <CustomContainer>
            <Box>
              <PlanHeader>
                <Box>
                  <Typography
                    variant="body1"
                    sx={{ fontSize: 24, fontWeight: 600 }}
                  >
                    {content?.tabTitle}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontSize: 16, fontWeight: 500 }}
                  >
                    {content?.tabSubTitle}
                  </Typography>
                </Box>
              </PlanHeader>
              <PlanDetails style={{ flexDirection: "row !improtant" }}>
                <ChooseSavedCard />
              </PlanDetails>
            </Box>
          </CustomContainer>
        </Box>
      </Box>
    </Box>
  );
};

export default ChooseSavedCardPage;
